/* RESPONSIBLE TEAM: team-inbox-experience */

import { ExternalType } from 'embercom/objects/standalone/constants';

export default abstract class ConversationLike {
  abstract externalType?: ExternalType;

  get isExternalConversation(): boolean {
    return !!this.externalType;
  }

  get isZendeskConversation(): boolean {
    if (!this.externalType) {
      return false;
    }

    return [
      ExternalType.ZendeskTicket,
      ExternalType.ZendeskSunshineConversation,
      ExternalType.SunshineTicketTransfer,
    ].includes(this.externalType);
  }

  get isSalesforceConversation(): boolean {
    if (!this.externalType) {
      return false;
    }

    return [
      ExternalType.SalesforceCase,
      ExternalType.SalesforceLegacyChat,
      ExternalType.SalesforceInAppMessageConversation,
    ].includes(this.externalType);
  }

  get isHubspotConversation(): boolean {
    if (!this.externalType) {
      return false;
    }

    return this.externalType === ExternalType.HubspotConversation;
  }

  get isFreshdeskConversation(): boolean {
    if (!this.externalType) {
      return false;
    }

    return [ExternalType.FreshdeskTicket, ExternalType.FreshchatConversation].includes(
      this.externalType,
    );
  }
}
